import { interval } from 'rxjs';
import { useObservable } from 'rxjs-hooks';
import { map } from 'rxjs/operators';

export const useLiveDate = (granularity: number) =>
  useObservable(
    () => interval(granularity).pipe(map(() => new Date())),
    new Date(),
  );
